export const STARTER_PACK_PRICE = 7.99;

// prices: https://dashboard.stripe.com/acct_1SLSduEwjPZIXeGx/products/prod_TJ3HMRX5Sz3hcO

export const STARTER_PACK_DOWNLOAD_CREDITS = 30;

export const formatPrice = (price: number) => `$${price.toFixed(2)}`;
